<template>
  <b-modal
      centered
      modal-class="cy-current-item-modal"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      v-model="isOpen"
      data-cy="company-modal-archive"
    >
      <b-container fluid>
        <b-button
          @click="closeModal"
          class="cy-current-item-close d-flex position-absolute close-btn"
        >
          <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt />
        </b-button>
        <b-row class="pt-2 pl-4 d-flex flex-column">
          <h2
            v-if="isItemArchived"
            class="font-md cy-current-item-success-header modal_header ml-2"
          >
            Successfully {{ actionLabel }}
          </h2>

          <h4
            v-if="!isItemArchived"
            class="font-md cy-current-item-subtext subtext mb-4 mt-3 ml-2"
          >
            Do you want to {{ actionLabel }} the following item?
          </h4>
          <h4
            v-else
            class="font-md cy-current-item-subtext-success subtext mb-4 mt-1 ml-2"
          >
            Following item has been successfully {{ actionLabel }}.
          </h4>
        </b-row>

        <b-row align-v="center">
          <b-col class="flex-row d-flex mb-4">
            <div>
              <b-avatar
                v-if="avatarThumbnail"
                :src="avatarThumbnail"
                size="8rem"
                class="pa-avatar bg--primary"
              ></b-avatar>
              <b-avatar
                v-else
                :text="getInitialsFromName(name)"
                size="8rem"
                class="pa-avatar bg--primary"
              ></b-avatar>
            </div>
            <div
              class="d-flex flex-column justify-content-center position-relative ml-4"
            >
              <p
                class="cy-current-item-name font-family-medium primary--text mt-2"
              >
                {{ name }}
              </p>
              <div class="">
                <b-button
                  class="text-uppercase btn-chip btn-danger--light danger font-family-regular btn-chip--pill"
                  >{{ `${subscriptionType} membership` }}</b-button
                >
              </div>
            </div>
          </b-col>

          <div>
            <b-button
              @click="isUnArchive ? emitUnArchive(id) : emitArchive(id)"
              v-if="!isItemArchived"
              :class="{'btn-danger': isActive }"
              class="cy-current-item-archive btn-primary px-5 mr-4 py-3 btn-pill ml-2 reduce-whitespace"
              data-cy="company-button-archive-confirm"
            >
              <b-spinner
                v-if="isProcessing"
                style="width: 14px; height: 14px"
                variant="light"
                label="Spinning"
              ></b-spinner>
              {{ `${isProcessing ? "" : archiveBtnText}` }}
            </b-button>
          </div>
        </b-row>
        <b-row v-if="archiveError" class="archive-error">
          <b-col>
            {{ archiveError }}
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
</template>

<script>
import { getInitialsFromName } from "@/utils/utils";

export default {
  props: {
    isOpen: { type: Boolean },
    isProcessing: { type: Boolean },
    isUnArchive: { type: Boolean },
    archiveError: { type: String },
    id: { type: String },
    name: { type: String },
    subscriptionType: { type: String },
    avatarThumbnail: { type: String },
  },

  data() {
    return  {
      isItemArchived: false,
    }
  },

  computed: {
    actionLabel() {
      return this.isUnArchive ? "unarchive" : "archive"
    },

    isActive() {
      return !this.isUnArchive
    },

    archiveBtnText() {
      const [first, ...rest] = this.actionLabel.split("")
      return `${first.toUpperCase()}${rest.join("")}` 
    }
  },

  methods: {
    getInitialsFromName,

    closeModal() {
      this.$emit('close-archive-modal')
    },

    emitArchive(id) {
      this.$emit('confirm-archive', id)
    },

    emitUnArchive(id) {
      this.$emit('confirm-unarchive', id)
    }
  }
}
</script>

<style scoped>
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
</style>